import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { MenuDescriptionsResponse } from "@/shared/utils/interfaces";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

// A description for every product without one, products that have one are left alone.
// Nothing is saved, a big menu takes about half a minute
const useMenuDescriptionsPost = () => {
  const branch = useBranchId();

  const mutation = useMutation<MenuDescriptionsResponse, AxiosError>({
    mutationFn: () =>
      post2(`internal/secure/pos/v1/menus/descriptions/${branch}`),
  });

  return mutation;
};

export default useMenuDescriptionsPost;
